// extracted by mini-css-extract-plugin
export default {"error-container":"RbHPvnR3","title":"MsCSp1GR","sub-title":"LPWvIgVf","icon":"J2Ls06T_","reset-container":"yT2NMLCE","login-box":"qhS91QGN"};